/*
* This version of verifyOrigin contains localhost by default for dev webpack build.
* port number may vary based on your setup but the default port used in server.js is 9999.
* if you are using a secure connection then you may want to update the localhost domain below to use https.
*/
export function verifyOrigin(origin) {
  const originLUT = [

    'https://apps.inindca.com',
    'https://apps.inintca.com',
    'https://apps.mypurecloud.jp',
    'https://apps.apne2.pure.cloud',
    'https://apps.mypurecloud.com.au',
    'https://apps.aps1.pure.cloud',
    'https://apps.cac1.pure.cloud',
    'https://apps.mypurecloud.de',
    'https://apps.mypurecloud.ie',
    'https://apps.euw2.pure.cloud',
    'https://apps.mypurecloud.com',
    'https://apps.usw2.pure.cloud',
    'https://apps.use2.us-gov-pure.cloud',
    'https://apps.sae1.pure.cloud',
    'https://apps.mec1.pure.cloud',
    'https://apps.apne3.pure.cloud',
    'https://apps.euc2.pure.cloud',
    'https://apps.mxc1.pure.cloud',
    'https://apps.apse1.pure.cloud',
    'http://localhost:9999',
    'https://app-regional.inindca.com',
    'https://app-regional.inintca.com',
    'https://app-regional.mypurecloud.jp',
    'https://app-regional.apne2.pure.cloud',
    'https://app-regional.mypurecloud.com.au',
    'https://app-regional.aps1.pure.cloud',
    'https://app-regional.cac1.pure.cloud',
    'https://app-regional.mypurecloud.de',
    'https://app-regional.mypurecloud.ie',
    'https://app-regional.euw2.pure.cloud',
    'https://app-regional.mypurecloud.com',
    'https://app-regional.usw2.pure.cloud',
    'https://app-regional.use2.us-gov-pure.cloud',
    'https://app-regional.sae1.pure.cloud',
    'https://app-regional.mec1.pure.cloud',
    'https://app-regional.apne3.pure.cloud',
    'https://app-regional.euc2.pure.cloud',
    'https://app-regional.mxc1.pure.cloud',
    'https://app-regional.apse1.pure.cloud'
  ];

  for (let i=0; i<originLUT.length;i++) {
    if (originLUT[i] === origin) return true;
  }

  return false;
}